<template>
  <div class="l-empty">
    <img :src="imgSrc" alt="" :style="{width: imgWidth + 'px'}">
    <div class='text'>{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: 'PtIndex',
  props: {
    text: {
      type: String,
      default: ''
    },
    imgSrc: {
      type: String,
      default: require('@/assets/img/bj_findzanwu@2x.png')
    },
    imgWidth: {
      type: Number,
      default: 284
    },
    fontSize: {
      type: Number,
      default: 14
    }
  },
  data() {
    return {}
  },

  mounted() {
    setTimeout(() => {
      console.log('imgSrc ----->', this.imgSrc)
    }, 500)
  },

  methods: {}
}
</script>

<style lang="less" scoped>
.l-empty {
  margin: 186px 0;
  img {
    height: auto;
  }
}
.text{
  font-weight: 400;
  font-size: 12px;
  color: #0D2340;
  margin-top: -60px;
}
</style>
